import React from "react";
import { Text, View } from "react-native";
import colors from "@constants/color";
import CrossIcon from "../../assets/svg/CrossCircle";

const KYCComment = (props) => {
  const { kycComment } = props;
  return typeof kycComment === "string" && kycComment.length ? (
    <View
      style={{
        backgroundColor: "rgba(255,0,0,0.05)",
        borderColor: colors.primary,
        borderRadius: 10,
        borderWidth: 1,
        padding: 2,
        flexDirection: "row",
        paddingHorizontal: 10,
        marginBottom: 8,
      }}
    >
      <CrossIcon style={{ marginTop: 10 }} />
      <Text
        style={{
          padding: 10,
          color: "rgba(0,0,0,0.86)",
          textAlignVertical: "center",
        }}
      >
        {kycComment}
      </Text>
    </View>
  ) : null;
};

export default KYCComment;
